{
  "autoZoom": "Zoom automatico",
  "averageApplicationRateWithVal": "Tasso medio di applicazione: {{val}}",
  "averagePressureWithVal": "Pressione media: {{val}}",
  "averageSpeedWithVal": "Velocità media: {{val}}",
  "contrast": "Aumenta il contrasto",
  "durationWithVal": "Durata: {{val}}",
  "linkTo": "Storia dell'irrigazione",
  "noReelRuns": "Nessuna corsa è stata registrata durante l'intervallo di date selezionato. Modifica l'intervallo di date o controlla più tardi",
  "runsListTitle": "Rullo corre",
  "selectedRunTitleWithRunCount": "Esegui {{selectedRunIndex}} di {{runCount}}",
  "showBorders": "Mostra contorni",
  "startDateWithVal": "Data di inizio: {{val}}",
  "tabGraphs": "Grafici",
  "tabRuns": "Corse",
  "title": "Storia dell'irrigazione",
  "totalApplicationWithVal": "Applicazione totale: {{val}} acri-pollici.",
  "totalRunsWithItemCount": "Numero totale di corse: {{itemCount}}",
  "applicationType": {
    "water": "Acqua",
    "manure": "Liquame",
    "other": "Altro"
  },
  "applicationTypeWithVal": "Applicato: {{val}}"
}
